import React from "react";

export default function Privacy() {
  const banner = (
    <div style={{
      width: '100vw',
      margin: 0,
      left: 0,
      right: 0,
      textAlign: 'center',
      background: 'linear-gradient(120deg, rgba(44,83,100,0.93) 60%, rgba(15,32,39,0.93) 100%)',
      backdropFilter: 'blur(8px) saturate(1.15)',
      WebkitBackdropFilter: 'blur(8px) saturate(1.15)',
      borderRadius: 0,
      boxShadow: '0 2px 18px 0 #00FFD044, 0 1.5px 8px 0 #00A3FF22',
      padding: '0.9rem 1.2rem 0.8rem 1.2rem',
      border: 'none',
      position: 'relative',
      zIndex: 2,
      marginTop: 0
    }}>
      <div style={{
        fontSize: '1.32rem',
        color: '#f3f6fa',
        fontWeight: 600,
        letterSpacing: '0.01em',
        marginBottom: '0.3rem',
        textShadow: '0 1.5px 8px #2c536466'
      }}>Privacy</div>
      <div style={{
        width: 54,
        height: 4,
        background: 'linear-gradient(90deg,#FFD600 0%,#2c5364 100%)',
        borderRadius: 4,
        margin: '0.4rem auto 0.7rem auto'
      }} />
    </div>
  );
  return (
    <>
      {banner}
      <div className="about-card" style={{marginTop: '2.5rem'}}>
        <h2 style={{fontWeight: 700, color: '#2c5364', marginBottom: '1.2rem'}}>Privacy Policy</h2>
        <p>Last updated: August 12, 2025</p>
        <h3>1. Introduction</h3>
        <p>LightTradeFOREX Academy ("we," "us," or "our") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, and safeguard your information when you use our website and services.</p>
        <h3>2. Information We Collect</h3>
        <ul>
          <li><strong>Personal Information:</strong> Name, email address, and other information you provide when registering or contacting us.</li>
          <li><strong>Google User Data (via Google Sign‑In):</strong> If you choose to authenticate with Google, we may receive your Google account basic profile information such as your name, email address, profile image, and Google user ID, limited to the scopes you authorize. We do <em>not</em> request or store your Google password.</li>
          <li><strong>Usage Data:</strong> Information about how you use our site, such as pages visited, time spent, and device/browser details.</li>
        </ul>
        <h3>3. How We Use Information</h3>
        <ul>
          <li>To provide and improve our educational services and site features</li>
          <li>To authenticate users and manage accounts (including via Google Sign‑In)</li>
          <li>To communicate with you about updates, programs, and support</li>
          <li>To analyze usage and improve user experience</li>
          <li>To comply with legal, security, and regulatory obligations</li>
        </ul>
        <h3>4. Cookies & Tracking</h3>
        <p>We use cookies and similar technologies to enhance your experience and analyze site usage. You may disable cookies in your browser settings, but some features may not function properly.</p>
        <h3>5. Third-Party Services</h3>
        <p>We may use third-party services (such as analytics or payment processors) that collect, use, and share your information according to their own privacy policies. We are not responsible for the privacy practices of these third parties.</p>
        <h3>Sharing and Disclosure of Google User Data</h3>
        <p>
          We do <strong>not</strong> sell Google user data to third parties. We only share Google user data with service providers as necessary to operate and improve our services, for example:
        </p>
        <ul>
          <li><strong>Firebase</strong> (authentication, hosting, and database)</li>
          <li><strong>Paystack</strong> (payment processing; no Google credentials are shared)</li>
        </ul>
        <p>
          These providers act as processors on our behalf and are bound by agreements to protect your information. We may also disclose information if required by law or to protect our rights, users, or the public.
        </p>
        <h3>Data Retention</h3>
        <p>
          We retain personal information, including Google user data, for as long as your account is active or as needed to provide services and meet legal, accounting, or reporting requirements. When no longer needed, we will delete or anonymize the data within a commercially reasonable timeframe.
        </p>
        <h3>Data Deletion and User Choices</h3>
        <p>
          You may request deletion of your account and associated personal information (including Google user data) by contacting us at <a href="mailto:lighttradeforex@gmail.com">lighttradeforex@gmail.com</a>. Upon verified request, we will delete or anonymize your personal information unless retention is required by law (e.g., for fraud prevention or record‑keeping).
        </p>
        <h3>6. Data Security</h3>
        <p>We implement reasonable security measures to protect your information. However, no method of transmission over the Internet or electronic storage is 100% secure.</p>
        <h3>7. Children's Privacy</h3>
        <p>Our services are not intended for children under 18. We do not knowingly collect personal information from children. If you believe a child has provided us with personal data, please contact us.</p>
        <h3>8. Changes to This Policy</h3>
        <p>We may update this Privacy Policy from time to time. Changes will be posted on this page with an updated effective date.</p>
        <h3>9. Contact Us</h3>
        <p>If you have any questions about this Privacy Policy or our handling of Google user data, please contact us at <a href="mailto:lighttradeforex@gmail.com">lighttradeforex@gmail.com</a>.</p>
      </div>
    </>
  );
}
